


























import { computed, defineComponent, PropType, watch, ref, toRefs } from '@vue/composition-api';
import DropdownPanel from '@/components/common/dropdown-panel/index.vue';
import { AvatarIcon, FullNormalFormData, AcoFormData } from '@tt4b/ttam-enums';
import { useIdentityAvatarUrl } from '../../hooks';
import List from './list.vue';

const name = 'ttam-delivery-tiktok-identity';
export default defineComponent({
  name,
  components: {
    List,
    DropdownPanel,
  },
  props: {
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    genListOptionsFunction: {
      type: Function,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const { creativeData } = toRefs(props);
    const popperVisible = ref(false);

    const curItem = computed(() => creativeData.value?.identityData);
    const curName = computed(() => curItem.value?.displayName ?? curItem.value?.identityId);
    const curAvatar = computed(() => useIdentityAvatarUrl(curItem.value?.avatarIcon as AvatarIcon));

    watch(popperVisible, v => {
      emit('popper-visible', v);
    });

    const onChange = data => {
      emit('change', data);
      popperVisible.value = false;
    };

    return {
      name,
      curName,
      curAvatar,
      popperVisible,

      onChange,
    };
  },
});
